import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ScormSession } from '../_models/ScormSession';
import { ScreenerResultDto } from '../_models/ScreeneResultDto';
import { APP_CONFIG } from '../lib/angular/injection-tokens';
import { IAppConfig } from '../lib/config/app-config';

@Injectable({
  providedIn: 'root',
})
export class PublicScreenerResultService {
  private baseUrl: string = this.config.publicBaseUrl;
  private static readonly path: string = 'PublicScreenerResult/';

  constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: IAppConfig) {}

  saveScreenerResult$(screenerId: number, session: ScormSession) {
    if (!session.open) {
      return null;
    }

    session.scormEntries.forEach((entry) => {
      entry.scormSessionId = 0;
    });

    let dto = new ScreenerResultDto();
    dto.screenerId = screenerId;
    dto.objectId = session.objectId;
    dto.entries = session.scormEntries;

    return this.http.post<ScreenerResultDto>(
      this.baseUrl + PublicScreenerResultService.path,
      dto
    );
  }
}
